module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "global-search"
  }, [_c('section', {
    staticClass: "top-wrapper"
  }, [_c('p', {
    staticClass: "back",
    on: {
      "click": _vm.goBackCommunity
    }
  }, [_c('img', {
    attrs: {
      "height": "28px",
      "width": "28px",
      "src": require("../../images/community/arrows-left.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("搜索结果")])]), _vm._v(" "), _c('div', {
    staticClass: "center-content"
  }, [_c('search-select', {
    staticClass: "global-search-select",
    attrs: {
      "placeholder": "请输入关键字或选择标签",
      "searchSelectValue": _vm.searchSelectValue
    },
    on: {
      "onClearSelectTag": _vm.onClearSelectTag,
      "change": _vm.handleSearchSelectChange,
      "clear": _vm.handleClearSearchSelect
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "topic-tabs"
  }, [_vm._l((_vm.topicTypeList), function(item) {
    return _c('li', {
      key: item.id,
      class: ['tabs__item', {
        'is-active': _vm.curTypeTab === item.id
      }],
      on: {
        "click": function($event) {
          return _vm.onTopicTypeToggle(item.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', [_vm._v("（")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('span', [_vm._v("）")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "tabs-bar",
    style: ({
      'transform': ("translateX(" + (_vm.tabIndex * 120) + "px)")
    })
  })], 2)], 1)]), _vm._v(" "), _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isProductLoading),
      expression: "isProductLoading"
    }],
    staticClass: "bottom-wrapper"
  }, [_c('div', {
    staticClass: "best-area"
  }, [_c('div', {
    staticClass: "best-list"
  }, _vm._l((_vm.bestList), function(item) {
    return _c('span', {
      key: item.id,
      class: ['best-item', {
        'active': item.type === _vm.curBestTab
      }],
      on: {
        "click": function($event) {
          _vm.curBestTab = item.type
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                ")])
  }), 0), _vm._v(" "), _c('p', {
    class: ['label-filter', {
      'active': _vm.isShowLabelFilter
    }],
    on: {
      "click": function($event) {
        _vm.isShowLabelFilter = !_vm.isShowLabelFilter
      }
    }
  }, [_c('span', [_vm._v("标签筛选")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../images/community/hover-angle-up.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), (_vm.isShowLabelFilter) ? _c('div', {
    staticClass: "label-area"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("热门标签：")]), _vm._v(" "), _c('div', {
    staticClass: "label-list"
  }, _vm._l((_vm.hotTagsList), function(item) {
    return _c('li', {
      key: item.title,
      class: ['label-item', {
        'active': _vm.selectedTagList.includes(item.title)
      }]
    }, [_c('span', {
      attrs: {
        "slot": "reference"
      },
      on: {
        "click": function($event) {
          return _vm.onSelectTag(item)
        }
      },
      slot: "reference"
    }, [_vm._v("\n                        " + _vm._s(item.title) + "\n                    ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.topicList.length) ? _c('ul', {
    staticClass: "topic-list"
  }, _vm._l((_vm.topicList), function(item, index) {
    return _c('li', {
      key: index,
      class: ("data-item data-item" + (item.id))
    }, [(item.board === 'qa') ? _c('topicContainer', {
      attrs: {
        "topicInfo": item,
        "fixedCommentId": _vm.fixedCommentId,
        "isSearch": true,
        "isLogin": _vm.isLogin
      },
      on: {
        "tagSelector": _vm.onSelectCommentTag,
        "onApproval": _vm.onApproval,
        "onShowAllComment": _vm.onShowAllComment,
        "focusToggle": _vm.focusToggle
      }
    }) : _c('articleContainer', {
      attrs: {
        "articleInfo": item,
        "isSearch": true,
        "isLogin": _vm.isLogin
      },
      on: {
        "tagSelector": _vm.onSelectCommentTag,
        "onVoteToggle": _vm.onVoteToggle,
        "favoriteToggle": _vm.favoriteToggle
      }
    })], 1)
  }), 0) : (!_vm.isProductLoading) ? _c('div', {
    staticClass: "search-null"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/developer/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("未搜索到相关的内容")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topicList.length),
      expression: "topicList.length"
    }],
    staticClass: "load-more"
  }, [(_vm.isLoading) ? _c('img', {
    attrs: {
      "alt": "loading",
      "src": require("../../images/common/loading_2_24x24.gif")
    }
  }) : (_vm.topicList.length === _vm.listCount) ? _c('p', {
    staticClass: "no-more"
  }, [_vm._v("没有更多问答了")]) : _c('p', {
    on: {
      "click": function($event) {
        return _vm.doLoadMore()
      }
    }
  }, [_vm._v("加载更多")])])]), _vm._v(" "), _c('goBack')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-ae85deec!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/search.vue
// module id = BgOc
// module chunks = 15